
import { Download, FileJson, FileSpreadsheet } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

// Export the selected month, or everything. The Content-Disposition header on
// the route forces the download; plain anchors keep the auth cookie attached.
export function ExportMenu({ month, scope }: { month: string; scope?: string }) {
  const href = (format: "csv" | "json", range: "month" | "all") => {
    const params = new URLSearchParams({ format });
    if (range === "month") params.set("month", month);
    if (scope) params.set("scope", scope);
    return `/api/expenses/export?${params.toString()}`;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Export expenses"
        className="flex size-9 items-center justify-center rounded-full text-muted-foreground outline-none transition-colors hover:bg-muted/40 hover:text-foreground data-[popup-open]:bg-muted/40"
      >
        <Download className="size-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuGroup>
          <DropdownMenuLabel>This month</DropdownMenuLabel>
          <DropdownMenuItem render={<a href={href("csv", "month")} download />}>
            <FileSpreadsheet />
            CSV
          </DropdownMenuItem>
          <DropdownMenuItem render={<a href={href("json", "month")} download />}>
            <FileJson />
            JSON
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuLabel>All time</DropdownMenuLabel>
          <DropdownMenuItem render={<a href={href("csv", "all")} download />}>
            <FileSpreadsheet />
            CSV
          </DropdownMenuItem>
          <DropdownMenuItem render={<a href={href("json", "all")} download />}>
            <FileJson />
            JSON
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
